import { AnswerType } from './answer-type';
import { Category } from './category';
import { Discipline } from './discipline.model';
import { TemplateModel } from './template-model.model';

export class Template {
    id: number;
    title: string;
    createdAt: Date;
    isEnabled: boolean;
    updatedAt: Date;
    expiredAt: string;
    questionsAmount: number;
    answerOptions: number;
    answerType: AnswerType;
    category: Category;
    models: TemplateModel[];
    disciplines: Discipline[];
    beginAt: string;
    transmission: string;
    hasAnswerKey = false;
    correctingModel: TemplateModel;
    isPublished: boolean;

    constructor(template?: { id?: number, title?: string, createdAt?: Date, isEnabled?: boolean,
                updateAt?: Date, expiredAt?: string, questionsAmount?: number,
                answerOptions?: number, answerType?: AnswerType, category?: Category, models?: TemplateModel[],
                disciplines?: Discipline[], beginAt?: string, transmission?: string, hasAnswerKey?: boolean,
                correctingModel?: TemplateModel, isPublished?: boolean }) {
                    if (template) {
                        this.id = template.id;
                        this.title = template.title;
                        this.createdAt = template.createdAt;
                        this.isEnabled = template.isEnabled;
                        this.updatedAt = template.updateAt;
                        this.expiredAt = template.expiredAt;
                        this.questionsAmount = template.questionsAmount;
                        this.answerOptions = template.answerOptions;
                        this.answerType = template.answerType;
                        this.category = template.category;
                        this.models = template.models;
                        this.disciplines = template.disciplines;
                        this.beginAt = template.beginAt;
                        this.transmission = template.transmission;
                        this.hasAnswerKey = template.hasAnswerKey;
                        this.correctingModel = template.correctingModel;
                        this.isPublished = template.isPublished;
                    }
    }

    public static sortTemplateBeginAt(a, b) {
        return new Date(b.beginAt).getTime() - new Date(a.beginAt).getTime();
    }

    public static sortTemplateTitle(a, b) {
        if (a.title > b.title) {
          return 1;
        } else if (a.title < b.title) {
          return -1;
        } else {
          return 0;
        }
      }
}

export class ITemplateFilter {
    title: string;
    transmissionBeginAt: string;
    transmissionEndAt: string;


    constructor(filter?: { title?: string, transmissionBeginAt?: string, transmissionEndAt?: string }) {
        if (filter) {
            this.title = filter.title;
            this.transmissionBeginAt = filter.transmissionBeginAt;
            this.transmissionEndAt = filter.transmissionEndAt;
        }
    }
}
